export const HELP_LINK = 'https://m4mh.app/help';
export const FEEDBACK_LINK = 'https://m4mh.app/feedback';
export const PRIVACY_LINK = 'https://m4mh.app/privacy-policy';
